// @flow

import React from 'react';
import type { Node } from 'react';
import { SliderContainer } from '../../../slider';

type Props = {
  slideshow: ?boolean,
  columnCount: number,
  children: Node,
};

const ColumnWrapper = ({
  columnCount,
  slideshow,
  children,
}: Props) => {
  if (!slideshow) {
    return children || null;
  }

  return (
    <SliderContainer
      totalSlides={columnCount}
    >
      {children}
    </SliderContainer>
  );
};

export default ColumnWrapper;
